import { Reporte606Service } from "services";
import { ResponseExceptionHandlerHelper } from "utils";

export const Reporte606Manager = (() => {
  const { handleException } = ResponseExceptionHandlerHelper();

  const imprimirPDF = (params) =>
    Reporte606Service.imprimirPDF(params).then((res) => {
      if (!res.Success) handleException(res);
      return res.Data;
    });

  const descargarExcel = (params) =>
    Reporte606Service.descargarExcel(params).then((res) => {
      if (!res.Success) handleException(res);
      return res.blob;
    });

  const descargarCSV = (params) =>
    Reporte606Service.descargarCSV(params).then((res) => {
      if (!res.Success) handleException(res);
      return res.blob;
    });

  return { imprimirPDF, descargarExcel, descargarCSV };
})();
